module.exports = __webpack_public_path__ + "static/media/logo.a87d0f35.svg";